import {RaEvent, RaEventType} from "./RaEvent";

export enum GESTURE_STATUS {
    begin_gesture,
    end_gesture
}

export class GestureEvent extends RaEvent {

    static TYPE:RaEventType = "gesture_event";

    public id:string;

    constructor(private _status:GESTURE_STATUS, id:string) {
        super(GestureEvent.TYPE)
    }

    public get status():GESTURE_STATUS {
        return this._status;
    }
}
